export const RESET = "RESET";
export const RESET_ACTION = "RESET_ACTION";

export const COMPANY_UPDATE_ACTION = "COMPANY_UPDATE_ACTION";
export const COMPANY_UPDATE_ACTION_FAIL = "COMPANY_UPDATE_ACTION_FAIL";
